import {SmetioSideMenu} from
    "./../../smetioSideMenu/SmetioSideMenu.js";

import {SmetioSideMenuItem} from
    "./../../smetioSideMenuItem/SmetioSideMenuItem.js";
    

export function render(){

    this.rangeInputAttributes["min"] = this.min;
    this.rangeInputAttributes["max"] = this.max;

    if(this.isEmpty(this.minText)){

        this.minText = this.min;

    };

    if(this.isEmpty(this.maxText)){

        this.maxText = this.max;

    };    


    this.rangeInputAttributes["value"] = this.defaultValue;

    this.resetBtnAttributes["hidden"] = this.withOutResetBtn;
    this.editableInputAttributes["hidden"] = this.withOutEditableTextInput;

    this.editableInputAttributes["value"] = this.defaultValue;

    let output = `
            
        <div  ${this.getAttributes(this.mainAttributes, false)}>

            <div class="smetio-ui-rangeSlider-sliderTextAndEditableInput">

                <div class="smetio-ui-rangeSlider-sliderTex">
                    ${this.sliderText}
                </div>            

                <div class="smetio-ui-rangeSlider-inputContainer smetio-ui-rangeSlider-editableInputContainer">
                    <input ${this.getAttributes(this.editableInputAttributes, false)} >
                </div> 

                <div ${this.getAttributes(this.resetBtnAttributes, false)}>
                    <i class="smetio-icon smetio-icon-refresh-ccw"></i>
                </div>

            </div>

            <div class="smetio-ui-rangeSlider-sliderInputsDiv">

                <div class="smetio-ui-rangeSlider-inputContainer smetio-ui-rangeSlider-rangeInputContainer">
                    <span ${this.getAttributes(this.minTextAttributes, false)}>
                        ${this.minText}
                    </span>

                    <input ${this.getAttributes(this.rangeInputAttributes, false)} >
                    
                    <span ${this.getAttributes(this.maxTextAttributes, false)}>
                        ${this.maxText}
                    </span>
                </div>  

            </div>

        </div>
   
    `;

    this.events();

    return output;

};





